module.exports = __webpack_public_path__ + "img/photo-3.0bd2de87.jpg";